<template>
<div ref="scrollContainer" id="page-panel" v-loading="fullScreenLoading" class="scrollable only-y">
   <div class="customer-top-nav" style="margin-top:10px;">
      <el-page-header @back="close()" style="float:left;">
         <div slot="title">
            <span class="hidden-sm-and-down">{{$t('common.back')}}</span>
         </div>
         <div slot="content">
            <el-tooltip v-if="!isCustomerActive" :content="$i18n.t('clients.deactivatedCustomer')" placement="top">
               <i  class="mdi mdi-account-off"></i>
            </el-tooltip>
            <span v-else>
               <el-tooltip v-if="isIndividual" :content="$i18n.t('clients.individual')" placement="top">
                  <i class="mdi mdi-account-circle align-vertical-middle customer-type"></i>
               </el-tooltip>
               <el-tooltip v-else :content="$i18n.t('clients.corporate')"  placement="top">
                  <i class="mdi mdi-city align-vertical-middle customer-type"></i>
               </el-tooltip>
            </span>
            <span :class="{inactive : !isCustomerActive}">{{customerNameValue}}</span>
         </div>
      </el-page-header>
      <div class="customer-controls" style="float:right;">
         <!-- <el-button @click="close();">{{$t('buttons.close')}}</el-button> -->
         <el-dropdown v-if="$can('write', 'Customer')">
            <el-button type="primary">
               Actions <i class="el-icon-arrow-down"></i>
               <!-- <i class="el-icon-more"></i> -->
            </el-button>
            <el-dropdown-menu slot="dropdown" >
               <el-dropdown-item :disabled="!customer.active " @click.native="openCustomerEditor" ><i class="mdi mdi-account-edit"><span style="padding-left:5px;">{{$t('clients.editCustomer')}}</span></i></el-dropdown-item>
               <el-dropdown-item :disabled="!customer.active " @click.native="handleCreateNewSalesOrder" ><i class="mdi mdi-file-move"><span style="padding-left:5px;">{{$t('clients.createSalesOrder')}}</span></i></el-dropdown-item>
               <el-dropdown-item v-if="isInvoicingModuleactive === true" @click.native="handleShowWalletManagementDialog(true)"><i class="mdi mdi-credit-card-lock"><span style="padding-left:5px;">{{$t('clients.manageWallet')}}</span></i></el-dropdown-item>
               <el-dropdown-item v-if="isInvoicingModuleactive === true" :disabled="!customer.active" @click.native="createCredit"><i class="mdi mdi-credit-card-minus"><span style="padding-left:5px;">{{$t('clients.addCreditNote')}}</span></i></el-dropdown-item>
               <el-dropdown-item v-if="isInvoicingModuleactive === true"@click.native="openSenerateStatementFilter('SIMPLE')" divided><i class="mdi mdi-book-variant"><span style="padding-left:5px;">{{ $t('clients.simpleStatementReport') }}</span></i></el-dropdown-item>
               <!-- <el-dropdown-item v-if="isInvoicingModuleactive === true"@click.native="sendSimpleStatement"><i class="mdi mdi-email-fast"><span style="padding-left:5px;">{{ $t('clients.sendSimpleStatementReport') }}</span></i></el-dropdown-item> -->
               <el-dropdown-item v-if="isInvoicingModuleactive === true"@click.native="openSenerateStatementFilter" ><i class="mdi mdi-book-variant"><span style="padding-left:5px;">{{$t('clients.statementReport')}}</span></i></el-dropdown-item>
               <el-dropdown-item @click.native="downloadReservationUpcomingOrderReport" divided><i class="mdi mdi-file-pdf-box"><span style="padding-left:5px;">{{$t('clients.reservationNextSalesOrder')}}</span></i></el-dropdown-item>
               <el-dropdown-item @click.native="archiveCustomerControl" v-if="this.customer.active" :divided="true"><i class="mdi mdi-account-off"><span style="padding-left:5px;">{{$t('clients.deactivateCustomer')}}</span></i></el-dropdown-item>
               <el-dropdown-item @click.native="archiveCustomerControl" v-if="!this.customer.active" :divided="true"><i class="mdi mdi-account-star-outline"><span style="padding-left:5px;">{{$t('clients.activateCustomer')}}</span></i></el-dropdown-item>
               <el-dropdown-item @click.native="convertCustomer" ><i class="mdi mdi-account-convert"><span style="padding-left:5px;">{{$t('clients.convert')}} {{convertClientType}}</span></i></el-dropdown-item>
               <el-dropdown-item @click.native="deleteCustomer"><i class="mdi mdi-delete"><span style="padding-left:5px;">{{$t('clients.delete')}}</span></i></el-dropdown-item>
            </el-dropdown-menu>
         </el-dropdown>
      </div>
   </div>
   <el-row>
      <el-col>
         <el-link v-if="$can('read', 'ERP Report') && isInvoicingModuleactive === true" @click="handleCustomerStatisticVisibility" style="clear:both;float:right;" class="hidden-md-and-down fs-12 mt-10">
            <span v-if="customerStatisticVisible"><i class="el-icon-s-data" /> {{$t('clients.hideStats')}} <i class="el-icon-arrow-up" /></span>
            <span v-else> <i class="el-icon-s-data" /> {{$t('clients.showStats')}} <i class="el-icon-arrow-down" /></span>
         </el-link>
         <div v-if="customer && customer.tags" style="margin-left:20px;margin-bottom:20px;">
            <el-tag style="margin-right:5px;" v-for="tag in customer.tags" :key="tag.id">{{ tag.code }}</el-tag>
         </div>
      </el-col>
   </el-row>
   <el-row class="mt-20" v-if="isInvoicingModuleactive === true">
      <div v-if="$can('read', 'Invoices') && customerStatisticVisible" class="hidden-md-and-down" style="display:block">
         <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
               <InfoStatsCard  v-bind:text="$i18n.t('clients.stats.overdue')" v-bind:total="formatAmount(overdue)" v-bind:sign="'$'" v-bind:icon="'mdi mdi-clock'"  v-bind:status="'danger'" ></InfoStatsCard>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
               <InfoStatsCard v-bind:text="$i18n.t('clients.stats.outstanding')" v-bind:total="formatAmount(outstanding)" v-bind:sign="'$'" v-bind:icon="'mdi-eye'"  v-bind:status="'warning'" ></InfoStatsCard>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
               <InfoStatsCard  v-bind:text="$i18n.t('clients.stats.draft')" v-bind:total="formatAmount(draft)" v-bind:sign="'$'" v-bind:icon="'mdi mdi-file'"  v-bind:status="'success'" ></InfoStatsCard>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
               <InfoStatsCard  v-bind:text="$i18n.t('clients.stats.paid')" v-bind:total="formatAmount(total_paid)" v-bind:sign="'$'" v-bind:icon="'mdi-currency-usd'"  v-bind:status="'success'"></InfoStatsCard>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
               <InfoStatsCard  v-bind:text="$i18n.t('clients.stats.credit')" v-bind:total="formatAmount(credit)" v-bind:sign="'$'" v-bind:icon="'mdi-currency-usd-off'"  v-bind:status="'success'" ></InfoStatsCard>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
               <InfoStatsCard  v-bind:text="$i18n.t('clients.stats.total')" v-bind:total="formatAmount(total_revenue)" v-bind:sign="'$'" v-bind:icon="'mdi-currency-usd'"  v-bind:status="'success'"></InfoStatsCard>
            </el-col>
         </el-row>
      </div>
   </el-row>
   <el-card >
      <div style="width:100%;text-align:center;">
         <el-radio-group v-model="activeTab">
            <el-radio-button label="1"><i class="el-icon-notebook-2"/><span class="hidden-md-and-down">{{$t('clients.tabs.clientInfo')}}</span></el-radio-button>
            <el-radio-button label="2"><i class="el-icon-collection-tag"/><span class="hidden-md-and-down">{{$t('clients.tabs.reservations')}}</span></el-radio-button>
            <el-radio-button label="3"><i class="el-icon-shopping-cart-full"/><span class="hidden-md-and-down">{{$t('clients.tabs.sales')}}</span></el-radio-button>
            <el-radio-button label="4" v-if="isInvoicingModuleactive === true"><i class="el-icon-shopping-cart-full"/><span class="hidden-md-and-down">{{$t('clients.tabs.invoicesCreditNote')}}</span></el-radio-button>
            <!-- <el-radio-button label="4"><i class="el-icon-shopping-bag-2"/><span class="hidden-md-and-down">Achats</span></el-radio-button> -->
            <el-radio-button label="5" v-if="pageWidth>=420"><i class="el-icon-postcard"/><span class="hidden-md-and-down">{{$t('clients.tabs.communication')}}</span></el-radio-button>
            <el-radio-button label="6" v-if="pageWidth>=420"><i class="el-icon-files"/><span class="hidden-md-and-down">{{$t('clients.tabs.notes')}}</span></el-radio-button>
            <el-radio-button label="7" v-if="pageWidth>=420"><i class="el-icon-setting"/><span class="hidden-md-and-down">{{$t('clients.tabs.configuration')}}</span></el-radio-button>
         </el-radio-group>
         <el-radio-group v-model="activeTab" style="margin-top:10px;" v-if="pageWidth<420">
            <el-radio-button label="5"><i class="el-icon-postcard"/><span class="hidden-md-and-down">{{$t('clients.tabs.communication')}}</span></el-radio-button>
            <el-radio-button label="6"><i class="el-icon-files"/><span class="hidden-md-and-down">{{$t('clients.tabs.notes')}}</span></el-radio-button>
            <el-radio-button label="7"><i class="el-icon-setting"/><span class="hidden-md-and-down">{{$t('clients.tabs.configuration')}}</span></el-radio-button>
         </el-radio-group>
      </div>
      <!-- Fiche client -->
      <div v-if="activeTab==1" :style="tabHeight">
         <el-row :gutter="20">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
               <h5>{{$t('clients.infos')}}</h5>
               <el-divider />
               <!-- <el-form label-position="right"> -->
               <el-row :gutter="10" v-if="customer!= null && customer.parent != null">
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                     <span class="fs-14" style="color:#606266">{{$t('clients.groupedUnderCsutomer')}} : </span>
                     <span class="fs-14">
                        <PortausLink :id="customer.parent.id" path="/customers/" :label="getCustomerName(customer.parent)"></PortausLink>
                     </span>
                  </el-col>
               </el-row>
               <el-row :gutter="10">
                  <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                     <span class="fs-14" style="color:#606266">{{$t('clients.customerNumber')}} : </span>
                     <span class="fs-14">{{customer.id}}</span>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                     <span class="fs-14" style="color:#606266">{{$t('clients.type')}} : </span>
                     <span class="fs-14">{{getTypeOfCustomer}}</span>
                  </el-col>
               </el-row>
               <el-row :gutter="10">
                  <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                     <span class="fs-14" style="color:#606266">{{isIndividual ? $t('clients.customerName') :  $t('clients.companyName')}} : </span>
                     <span class="fs-14">{{customer.name}}</span>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" v-if="!isIndividual && customer.usual_name!=null && customer.usual_name!=''">
                     <span class="fs-14" style="color:#606266">{{$t('clients.usualName')}} : </span>
                     <span class="fs-14">{{customer.usual_name}}</span>
                  </el-col>
               </el-row>
               <el-row :gutter="10" v-if="!isIndividual">
                  <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" >
                     <span class="fs-14" style="color:#606266">{{$t('clients.phone')}} : </span>
                     <span class="fs-14">{{customer.company.phone?customer.company.phone: $t('common.notAvailable')}}</span>
                     <span class="fs-14" v-if="customer.company.phoneExt!=null && customer.company.phoneExt!=''">
                        <nobr> Ext.: {{customer.company.phoneExt}}</nobr>
                     </span>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                     <span class="fs-14" style="color:#606266">{{$t('clients.email')}} : </span>
                     <Email :email="customer.company.email" :mailTo="true"></Email>
                  </el-col>
               </el-row>
               <el-row :gutter="10">
                  <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                     <span class="fs-14" style="color:#606266">{{$t('clients.class')}} : </span>
                     <span class="fs-14">{{customer.customer_class?customer.customer_class.code: $t('common.notAvailable')}}</span>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                     <span class="fs-14" style="color:#606266">{{$t('clients.tags')}} : </span>
                     <span class="fs-14" v-if="customer!=null">
                        <el-tag style="margin-left:5px;" v-for="tag in customer.tags" :key="tag.id" >{{tag.code}}</el-tag>
                     </span>
                     <span class="fs-14" v-if="customer!=null && customer.tags!=null && customer.tags.length==0">{{ $t('common.notAvailable') }}</span>
                  </el-col>
               </el-row>
               <h5>{{$t('clients.repAndTerritory')}}</h5>
               <el-row :gutter="10">
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="12">
                     <span class="fs-14" style="color:#606266">{{$t('clients.territory')}} : </span>
                     <span class="fs-14">{{customer.territory?customer.territory.code: $t('common.none')}}</span>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="12">
                     <span class="fs-14" style="color:#606266">{{$t('clients.rep')}} : </span>
                     <span class="fs-14">{{customer.rep?(customer.rep.first_name + ' ' + customer.rep.last_name):$t('common.none')}}</span>
                  </el-col>
               </el-row>
               <h5>{{$t('clients.personnalizedFiled')}}</h5>
               <el-divider />
               <span class="fs-14" style="color:#606266">{{$t('clients.externalId')}}</span>
               <span class="fs-14">{{customer.externalId}}</span>
               <!-- <div v-for="info in customer_fields" :key="info.id">
                  <span class="fs-14" style="color:#606266">{{getInfoTitle(info)}} : </span>
                  <span class="fs-14">{{info.value}}</span>
               </div> -->
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
               <h5 v-if="!isIndividual">{{$t('clients.principalContact')}}</h5>
               <h5 v-else>{{$t('clients.contact')}}</h5>
               <el-divider />
               <ContactCards @onAccountChange="handleChangeAccount" :customerId="this.customer.id" v-bind:contacts="getContacts" type="primary"  :webAccounts="webAccounts" v-bind:isIndividual="isIndividual"></ContactCards>
               <div v-if="!isIndividual">
                  <h5>{{$t('clients.secondaryContact')}}</h5>
                  <el-divider />
                  <ContactCards @onAccountChange="handleChangeAccount" :customerId="this.customer.id"  v-bind:contacts="getContacts"	type="secondary"  :webAccounts="webAccounts" ></ContactCards>
               </div>
               <h5>{{$t('clients.addresses')}}</h5>
               <el-divider />
               <div >
                  <AddressCard v-for="address in getAddresses" :key="address.id" :ctrlVisible="false" shadow="never" :address="address" style="margin:10px;"></AddressCard>
                  <div v-if="getAddresses!=null && getAddresses.length==0" class="secondary-text fs-14 m-20">{{$t('clients.noAddresses')}}</div>
               </div>
            </el-col>
         </el-row>
      </div>
      <!-- Réservations -->
      <div v-if="activeTab==2 && $can('read', 'SalesOrders')" :style="tabHeight">
         <CustomerReservations :customerId="customerId"></CustomerReservations>
      </div>
      <!-- Ventes -->
      <div v-if="activeTab==3 && $can('read', 'SalesOrders')" :style="tabHeight">
         <el-row :gutter="20" class="mt-20">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
               <salesGraphics :customerId="customer.id" title="Évolution des ventes (12 derniers mois)"></salesGraphics>
            </el-col>
			<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
				<el-col :xs="24" :sm="12" :md="24" :lg="24" :xl="24">
					<InfoStatsCard  text="Valeur" v-bind:total="totalSales.value" v-bind:sign="'$'" v-bind:icon="'mdi mdi-account-cash'"  v-bind:status="'accent'" ></InfoStatsCard>
					
					</el-col>
					<el-col :xs="24" :sm="12" :md="24" :lg="24" :xl="24">
					<InfoStatsCard  text="Frais d'agence" v-bind:total="totalSales.agencyfees" v-bind:sign="'$'" v-bind:icon="'mdi mdi-bank'"  v-bind:status="'success'" ></InfoStatsCard>
					
					</el-col>
					<el-col :xs="24" :sm="12" :md="24" :lg="24" :xl="24">
					<InfoStatsCard  text="Rabais" v-bind:total="totalSales.discount" v-bind:sign="'$'" v-bind:icon="'mdi mdi-bank-minus'"  v-bind:status="'warning'" ></InfoStatsCard>
					
					</el-col>
					<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" v-if="!isMultipleInventorySystem">
					<InfoStatsCard  text="Qty bt." v-bind:total="totalSales.qty" v-bind:sign="''" v-bind:icon="'mdi mdi-numeric-1-circle'"  v-bind:status="'info'" ></InfoStatsCard>
					
					</el-col>
					<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12"  v-if="!isMultipleInventorySystem">
					<InfoStatsCard  text="Qty 9L" v-bind:total="totalSales.qty9l" v-bind:sign="''" v-bind:icon="'mdi mdi-numeric-9-circle-outline'"  v-bind:status="'info'" ></InfoStatsCard>
					
				</el-col>
			</el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
               <h4>{{$t('clients.currentSalesOrder')}}</h4>
               <div class="flex center m-10 mt-10">
                  <Pagination
                     class="box right mt-5 mb-0 fs-14 secondary-text"
                     :current-page="page"
                     :total-number-of-page="totalPages"
                     @click-previous="fetchPreviousSalesOrderPage"
                     v-if="isNotEmpty"
                     @click-next="fetchNextSalesOrderPage" />
               </div>
               <el-divider/>
               <salesOrderTable :customerId="customerId" :salesOrders="salesOrders" height="100%" class="mb-20"></salesOrderTable>
            </el-col>
         </el-row>
      </div>
      <!-- facturation -->
      <div v-if="activeTab==4 && $can('read', 'Invoices')&& isInvoicingModuleactive === true" :style="tabHeight">
         <el-row :gutter="20">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
               <!-- <el-link type="primary" style="float:right;margin-top:20px;">Voir toutes les factures</el-link> -->
               <h5>{{$t('clients.invoices')}}</h5>
               <el-divider/>
               <invoiceTable  :showFilter="true" :showDetails="false" :sortingOrder="date" sortingDirection='DESC' :paging="true" :perPage="15" :customerId="customerId" :filter="{statusCode : ['DRAFT','SENT','PARTIALLY_PAID', 'TO_SEND', 'PAID', 'IMPORTED']}" :sortable="true" :admin="true"></invoiceTable>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
               <h5>{{$t('clients.creditsNotes')}}</h5>
               <el-divider/>
               <creditNoteTable :customerId="customerId" :filter="{statusCodes : ['INIT','PARTIALLY_PAID']}" :sortable="true"></creditNoteTable>
            </el-col>
         </el-row>
      </div>
      <!-- Communications -->
      <div v-if="activeTab==5 && $can('read', 'CRM report')" :style="tabHeight" class="scrollable only-y">
         <EmailsCommunicationTable :lazy="true" :customer="customer"></EmailsCommunicationTable>
      </div>
      <!-- Notes -->
      <div v-if="activeTab==6" :style="tabHeight">
         <el-col >
            <h5>
               Notes 
               <el-button  plain type="text" @click="handleShowQuickNoteVisible"><i class="el-icon-circle-plus" /></el-button>
            </h5>
            <el-divider/>
            <CustomerNoteHistory :customerId="customerId" @edit="handleNoteEdition"></CustomerNoteHistory>
         </el-col>
         <QuickNoteModal :customerId="customerId" :visible="quickNoteModalVisible" :note="noteToEdit" @close="handleCloseQuickNoteVisible"></QuickNoteModal>
      </div>
      <!-- configuration -->
      <div v-if="activeTab==7" :style="tabHeight">
         <el-row :gutter="20">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
               <h5>{{$t('clients.classification')}}</h5>
               <el-divider/>
               <el-row :gutter="10">
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                     <span class="fs-14" style="color:#606266">{{$t('clients.class')}} : </span>
                     <span class="fs-14">{{customer.customer_class?customer.customer_class.code : $t('common.notAvailable')}}</span>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                     <span class="fs-14" style="color:#606266">{{$t('clients.tags')}} : </span>
                     <span class="fs-14" v-if="customer!=null">
                        <el-tag style="margin-left:5px;" v-for="tag in customer.tags" :key="tag.id" >{{tag.code}}</el-tag>
                     </span>
                     <span class="fs-14" v-if="customer!=null && customer.tags!=null && customer.tags.length==0">{{ $t('common.notAvailable') }}</span>
                  </el-col>
               </el-row>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
               <h5>{{$t('clients.currencyLanguage')}}</h5>
               <el-divider/>
               <el-row :gutter="10">
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                     <span class="fs-14" style="color:#606266">{{$t('clients.currency')}} : </span>
                     <span class="fs-14">{{customer.currency!=null?customer.currency.code: $t('common.notAvailable')}}</span>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                     <span class="fs-14" style="color:#606266">{{$t('clients.language')}} : </span>
                     <span class="fs-14" v-if="customer.language!=null">{{customer.language.name}}</span>
                     <span class="fs-14" v-else>{{ $t('common.notAvailable') }}</span>
                  </el-col>
               </el-row>
            </el-col>
         </el-row>
         <el-row :gutter="20" v-if="isInvoicingModuleactive === true">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
               <h5>{{$t('clients.paymentOptions')}}</h5>
               <el-divider/>
               <el-row :gutter="10">
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                     <span class="fs-14" style="color:#606266">{{$t('clients.paymentMethods')}} : </span>
                     <div v-if="customer!=null && customer.paymentOptions!=null && customer.paymentOptions.length>0">
                        <ul>
                           <div v-for="option in customer.paymentOptions">
                              <li><span class="fs-14">{{$t('invoices.'+option.code)}}</span></li>
                           </div>
                        </ul>
                     </div>
                     <span v-else class="secondary-text fs-14">{{$t('clients.noPaymentMethod')}}</span>
                  </el-col>
               </el-row>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
               <h5>{{ $t('clients.invoicing') }}</h5>
               <el-divider/>
               <el-row :gutter="10">
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                     <span class="fs-14" style="color:#606266">{{ $t('clients.invoicingOption') }}: </span>
                     <span v-if="customer.online_invoicing_ind" class="fs-14">{{ $t('clients.onlineInvoicing') }}</span>
                     <span v-else class="fs-14">Man{{ $t('clients.manualInvoicing') }}uel</span>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                     <span class="fs-14" style="color:#606266">{{ $t('clients.term') }} : </span>
                     <span v-if="customer.invoice_term" class="fs-14">{{$t('invoices.terms.'+customer.invoice_term.code)}}</span>
                     <span v-else class="fs-14">{{ $t('common.notAvailable') }}</span>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                     <span class="fs-14" style="color:#606266">{{ $t('clients.lateFees') }} : </span>
                     <span class="fs-14">{{customer.late_fee_activated?'Oui':'Non'}}</span>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="customer.late_fee_activated">
                     <span class="fs-14" style="color:#606266">{{ $t('clients.fees') }} : </span>
                     <span class="fs-14">{{customer.fee}} {{customer.ind_type_fee==0?'%':'$'}}</span>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="customer.late_fee_activated">
                     <span class="fs-14" style="color:#606266">{{ $t('clients.when') }} : </span>
                     <span class="fs-14">{{customer.grace_period}} {{ $t('clients.daysAfter') }}</span>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                     <span class="fs-14" style="color:#606266">{{ $t('clients.taxesCode') }} : </span>
                     <span v-for="(taxe, index) in customer.taxes" :key="taxe.id" class="fs-14">{{taxe.name}}<span v-if="index < customer.taxes.length-1">, </span></span>
                  </el-col>
               </el-row>
            </el-col>
         </el-row>
         <el-row :gutter="20">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
               <h5>{{$t('clients.deliveryPref')}}</h5>
               <el-divider/>
               <el-row :gutter="10">
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                     <span class="fs-14" style="color:#606266">{{$t('clients.deliveryType')}} : </span>
                     <span class="fs-14" v-if="customer.delivery_type!=null">{{deliveryType}}</span>
                     <span class="fs-14" v-else>{{ $t('common.notAvailable') }}</span>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="customer.delivery_type!=null && customer.delivery_type.code=='DELIVERY'">
                     <BranchTile class="fs-14" style="border:1px dashed #DCDFE6;padding:10px;margin-top:10px;" v-if="customer.extra_info" :location="customer.extra_info.location.content"></BranchTile>
                  </el-col>
               </el-row>
               <el-row :gutter="10">
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                     <span class="fs-14" style="color:#606266">{{$t('clients.calendar')}} : </span>
                     <span class="fs-14">{{$t('clients.deliveryScheduleType.'+deliveryScheduleType)}}</span>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                     <span class="fs-14" style="color:#606266">{{$t('clients.deliveryDays')}} : </span>
                     <span class="fs-14">{{deliveryDays}}</span>
                  </el-col>
               </el-row>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
               <h5>{{$t('clients.notifications.notifications')}}</h5>
               <el-divider/>
               <el-row :gutter="10">
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                     <span class="fs-14" style="color:#606266">{{$t('clients.notifications.paymentReminder')}} : </span>
                     <span class="fs-14">{{customer.reminder_activated? $t('common.activated'):$t('common.notActivated')}}<span v-if="customer.reminder_activated">, {{customer.nb_days_reminder}} {{$t('clients.daysBefore')}}</span></span>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                     <span class="fs-14" style="color:#606266">{{$t('clients.notifications.lateFeeNotice')}} : </span>
                     <span class="fs-14">{{customer.late_fee_notification_activated? $t('common.activated'):$t('common.notActivated')}}</span>
                  </el-col>
               </el-row>
            </el-col>
         </el-row>
      </div>
      <CustomerEditor :visible="customerEditorVisible" :customerToEdit="customerToEdit" @close="closeCustomerEditor" @updated="refreshCustomer"></CustomerEditor>
      <CreditNoteEditor :visible="creditEditorVisible" :customer="customer" @close="creditEditorVisible=false"></CreditNoteEditor>
      <customerStatementFilter :visible="customerStatementVisible"
         predefinePeriodLabelCode='predefinedDate'
         @close="closeFilterDialog"
         :predefinedPeriod="predefinedPeriod"
         :period="period"
         :startDate="this.filters.startDate"
         :endDate="this.filters.endDate"
         @applyFilter="downloadStatement">
      </customerStatementFilter>
      <sendNoticeDialog  :visible="sendDialogVisible" :forceSendAttachment="true" :customerId="customerId" type="CUSTOMER_STATEMENT" :object="simpleStatementObject" @close="closeSendNoticeDialog" @sent="noticeSent"></sendNoticeDialog>
   </el-card>
   <SalesOrderDialog :customerId="customerId" :dialogVisible="showSalesOrderDialog" @close="showSalesOrderDialog = false"></SalesOrderDialog>
   <WatingDialog :visible="downloading"></WatingDialog>
   <walletManagement 
      :visible="walletDialogVisible" 
      :customerId="customer.id"
      :portausCompanyId="portausCompany" 
      @close="handleShowWalletManagementDialog(false)" />
</div>
</template>

<script>
import moment from 'moment-timezone'
import ContactCards from '@/components/Contact-card-by-type'
import InfoStatsCard from '@/components/Info-stat-card'
import portausUtils from '@/utils/portaus-utils';
import CompanyInfo from '@/components/Company-info'
import axios from "axios"
import VuePerfectScrollbar from 'perfect-scrollbar'
import AddressCard from '@/components/address/Address-Card'
import SystemAPI from '@/services/API/system'
import QuickNoteModal from '@/components/quick-note-modal.vue'
import SalesOrdersAPI from '@/services/API/sales-order'
import SalesOrderDialog from '@/components/salesOrder/create-sales-order-dialog';
import CustomerEditor from '@/components/customer/Customer-editor'
import CreditNoteEditor from '@/components/creditNote/credit-note-editor'
import salesOrderTable from '@/components/dashboards/sales-order/sales-order-table.vue'
import invoiceTable from '@/components/invoice/invoice-table.vue'
import creditNoteTable from '@/components/creditNote/credit-note-table.vue'
import customerStatementFilter from '@/components/customer/customer-statement-filter.vue'
import { mapActions, mapState, mapGetters } from 'vuex';
import BranchTile from '@/components/Branch-tile'
import Email from '@/components/email'
import CustomerAPI from '@/services/API/customer'
import salesAPI from '@/services/API/sales'
import WatingDialog from '@/components/waiting-dialog'
import PortausLink from '@/components/portaus-link'
import CustomerUtil from '@/utils/customer-util'
import Pagination from '@/components/pagination'
import accountAPI from '@/services/API/account'
import walletManagement from '@/components/payments/wallet-management-dialog'
import salesGraphics from '@/components/sales-graphic'
import sendNoticeDialog from '@/components/send-notice-dialog.vue'

export default {
   name: 'Customer',
  data() {
    return {
      downloading : false,
      simpleStatementObject: null,
      sendDialogVisible: false,
	  accessLoading: false,
      quickNoteModalVisible: false,
	  webAccounts: [],
	  fullScreenLoading: true,
			activeTab : 1,
  		customer : {company:{}, contacts: []},
			customer_fields : [],
	  	dialogvisible : false,
			salesOrders : [],
			pageWidth : 0,
			pageHeight : 0,
			customerEditorVisible : false,
			customerToEdit : null,
			creditEditorVisible : false,
			customerStatementVisible : false,
			filters : {
        range : null,
        startDate : null,
        endDate : null,
        customerId : null,
		
		
      },
			period : {code : 'LAST_12_MONTH'},
      customerStatisticVisible : true,
      noteToEdit: null,
      noteIndexToEdit: null,
	  page: 1,
	  totalPages: null,
	  salesOrderLimit: 15,
	  walletDialogVisible : false,
     totalSales: null,
     showSalesOrderDialog: false
	};
		
  },components: {
		CustomerEditor,
      ContactCards,
      InfoStatsCard,
      VuePerfectScrollbar,
      CompanyInfo,
      WatingDialog,
		AddressCard,
      sendNoticeDialog,
		CustomerNoteHistory : () => import('@/components/note-history.vue'),
		invoiceTable,
		QuickNoteModal,
		// salesOrderDashboardCard,
		salesOrderTable,
		CustomerReservations: () => import('@/components/reservation/customer-reservations'),
		EmailsCommunicationTable : () => import('@/components/emails/emails-communication-table.vue'),
		BranchTile,
		CreditNoteEditor,
		creditNoteTable,
		Email,
		customerStatementFilter,
      PortausLink,
      CustomerUtil,
		Pagination,
		walletManagement,
		salesGraphics,
      SalesOrderDialog,
  },
	methods: {
      handleCreateNewSalesOrder(){
         this.showSalesOrderDialog = true;
      },
      formatAmount(amount) {
          return portausUtils.formatAmount(amount, this.$i18n.locale);
		},
      sendSimpleStatement () {
         this.sendDialogVisible = true;
      },
      closeSendNoticeDialog () {
         this.sendDialogVisible = false;
      },
      noticeSent () {
         console.log('SENT');
      },
		fetchSales() {
			this.loading = true;
			const params = {
				customerId: this.customerId,
				}
			return salesAPI.getSalesEvolution(params)
			.then((sales) => {
            this.totalSales = _.head(sales);
				this.loading = false;
			})
		},
		getInfoTitle(info){
			return info[this.titleLang];
		},
		handleShowWalletManagementDialog(show) {
			if (show) {
				this.walletDialogVisible = true;
			} else {
				this.walletDialogVisible = false;
			}
		},
		handleChangeAccount (account) {
			if (this.customer.type === 0) {
				this.$set(this.customer.contact, 'account', account);
			} else {
				_.forEach(this.customer.company.contacts, c => {
					if (c.id === account.user.id) {
						this.$set(c, 'account', account);
					}
				})
			}
		},
 	fetchWebAccess () {
      if (this.isExternalAccountAPIModuleactive) {
         this.accessLoading = true;
            return accountAPI.fetchAccounts({ customerId: this.customer.id })
               .then((accounts) => {
                  this.webAccounts = accounts
                  this.accessLoading = false
               }).catch(() => {
                  this.accessLoading = false;
               })
      }
		
	},
    deleteCustomer() {
      return CustomerAPI.delete(this.customerId)
        .then(() => {
          this.invalidateList();
          this.$message.success(this.$i18n.t(`clients.deleted`));
          this.close();
        })
        .catch((error) => {
          if (error.response.status === 405) {
            let i18nMessage = null;
            const reasons = _.get(error.response, 'data.reasons');
            if (!_.isEmpty(reasons.reservations) && _.isEmpty(reasons.salesOrders) && _.isEmpty(reasons.invoices)) {
              i18nMessage = 'delete_error_reservations';
            } else if (_.isEmpty(reasons.reservations) && !_.isEmpty(reasons.salesOrders) && _.isEmpty(reasons.invoices)) {
              i18nMessage = 'delete_error_salesOrders';
            } else if (_.isEmpty(reasons.reservations) && _.isEmpty(reasons.salesOrders) && !_.isEmpty(reasons.invoices)) {
              i18nMessage = 'delete_error_invoices';
            } else if (!_.isEmpty(reasons.reservations) && !_.isEmpty(reasons.salesOrders) && _.isEmpty(reasons.invoices)) {
              i18nMessage = 'delete_error_reservations_salesOrders';
            } else if (!_.isEmpty(reasons.reservations) && _.isEmpty(reasons.salesOrders) && !_.isEmpty(reasons.invoices)) {
              i18nMessage = 'delete_error_reservations_invoices';
            } else if (_.isEmpty(reasons.reservations) && !_.isEmpty(reasons.salesOrders) && !_.isEmpty(reasons.invoices)) {
              i18nMessage = 'delete_error_salesOrders_invoices';
            } else {
              i18nMessage = 'delete_error_reservation_salesOrders_invoices';
            }

            this.$message.error(this.$i18n.t(`clients.${i18nMessage}`));
          } else {
            // this.$message.error("Oops... Une erreur est survenue!");
          }
        })
    },
    getCustomerName(customer){
      return CustomerUtil.customerName(customer.name, customer.usual_name, customer.type === 0);
    },
    downloadReservationUpcomingOrderReport(){
      this.downloading=true;
      let filename = this.customerNameValue + "-reservations-upcoming-orders.pdf"
      return salesAPI.downloadReservationUpcomingOrderReport({ customerId: this.customerId}, filename)
        .then(()=>{
          this.downloading=false;
        }).catch(err=>{
          this.downloading=false;
          this.$message.error("Oops... Une erreur est survenue!");
        })
    },
    handleNoteEdition ({ note, index }) {
      this.noteToEdit = note;
      this.noteIndexToEdit = index;
      this.handleShowQuickNoteVisible();
    },
    handleShowQuickNoteVisible (){
      this.quickNoteModalVisible = true;
    },
    handleCloseQuickNoteVisible (){
      this.noteToEdit = null;
      this.noteIndexToEdit = null;
      this.quickNoteModalVisible = false;
    },
		convertCustomer(){
			this.fullScreenLoading = true;
			CustomerAPI.convertCustomer(this.customer.id)
				.then(()=> this.getCustomerInfo(this.customer.id))
				.then(()=>{
					this.fullScreenLoading = false;
					this.$message.success('Le client a été converti avec succès!')
				})
				.catch(err=>{
					console.log(err);
          this.fullScreenLoading = false;
					this.$message.error("Oups... Une erreur est survenue!")
				})
		},
		downloadStatement(filters){
			let startDate = null;
			let endDate = this.month.endDate;
			if(filters.period.code!='CUSTOM'){
				if(filters.period.code=='FISCAL_YEAR'){
					startDate = this.fiscalYearDate.startDate.format('YYYY-MM-DD');
					endDate = this.fiscalYearDate.endDate.format('YYYY-MM-DD');
				}else if(filters.period.code=='LAST_FISCAL_YEAR'){
					startDate = this.lastFiscalYearDate.startDate.format('YYYY-MM-DD');
					endDate = this.lastFiscalYearDate.endDate.format('YYYY-MM-DD');
				}else if(filters.period.code=='MONTH'){
					startDate = this.month.startDate.format('YYYY-MM-DD');
					endDate = this.month.endDate.format('YYYY-MM-DD');
				}else if(filters.period.code=='LAST_MONTH'){
					startDate = this.lastMonth.startDate.format('YYYY-MM-DD');
					endDate = this.lastMonth.endDate.format('YYYY-MM-DD');
				}else if(filters.period.code=='LAST_12_MONTH'){
					startDate = this.last12Month.startDate.format('YYYY-MM-DD');
					endDate = this.month.endDate.format('YYYY-MM-DD');
				}
			}else{
				startDate = moment(filters.dateRange[0]).format('YYYY-MM-DD');
				endDate = moment(filters.dateRange[1]).format('YYYY-MM-DD');
			}

			let filename = this.customer.name + "-statement-"+startDate+"-"+endDate
		  CustomerAPI.downloadStatementReport(this.customer.id, startDate, endDate, filename);
		},
		closeFilterDialog(){
			this.customerStatementVisible = false;
		},
		openSenerateStatementFilter(type){
      if (type !== 'SIMPLE') {
	       this.customerStatementVisible = true;
      } else {
        let filename = this.customer.name + "-statement-"+ moment().format('YYYY-MM-DD');
        CustomerAPI.downloadStatementReportV2(this.customer.id, null, null, filename, 'SIMPLE');
      }

		},
		refreshCustomer(customerUpdated){
			Object.assign(this.customer, customerUpdated);
         if (customerUpdated.parent == null) {
            this.customer.parent = null;
         }
			this.setCustomerFields(customerUpdated.custom_fields);

		},
		openCustomerEditor(){
			this.customerToEdit = this.customer;
			this.customerEditorVisible=true;
		},
		closeCustomerEditor(){
			this.customerEditorVisible=false;
		},
		_moment(datetime, format='LL'){
      return moment(datetime).format(format);

		},
		openSalesOrder(salesOrderId){
			var index='/sales-orders/'+salesOrderId;
			this.$router.push(index);
		},
		close(){
			this.$router.go(-1);
		},
		createInvoice(){
			// var index='/invoice';
			// this.$router.push(index);
		},
		createCredit(){
			this.creditEditorVisible = true;
		},
		openSettingsDialog() {
			this.dialogvisible = true
		},
		setPageWidth() {
			if (document.getElementById('page-panel') != null) {
				this.pageWidth = document.getElementById('page-panel').offsetWidth;
				this.pageHeight = document.getElementById('page-panel').offsetHeight;
			}	
		},
		archiveCustomerControl(){
			var message = this.customer.active?"Voulez-vous vraiment désactiver le client?":"Voulez-vous vraiment réactiver le client?";
			this.$confirm(message, 'Warning', {
          confirmButtonText: 'Oui',
          cancelButtonText: 'Annuler',
          type: 'warning'
        }).then(() => {
					this.fullScreenLoading=true;
					var putValue = {};
					putValue.active = !this.customer.active;
					axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/customers/"+this.customerId, putValue)
						.then(response=>{
							this.invalidateList();
							this.customer.active=putValue.active;
							this.fullScreenLoading=false;
							var message = putValue.active?"Le client a été réactivé.":"Le client a été désactivé."
							this.$notify({
								title: 'Succès',
								message: message,
								type: 'success'
					        });
						}).catch((err) => {
							this.$notify({
								title: 'Ooops!',
								message: 'Une erreur est survenue. Veuillez réessayer plus tard.',
								type: 'error'
									});
		        });
        }).catch(()=>{
					//do nothing
				})
		},
		updateCustomerCredit({creditNoteCreated, customerCredits}){
			this.customer.credit.credit = customerCredits;
		},
		getCustomerInfo(){
			return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/customers/"+this.customerId)
			.then(response=>{
				return this.customer=response.data;
			})
		},
		fetchNextSalesOrderPage () {
			if (this.page < this.totalPages) {
				this.page += 1;
				this.getSalesOrders();
			}
		},
		fetchPreviousSalesOrderPage () {
			if (this.page > 1) {
				this.page -= 1;
				this.getSalesOrders();
			}
		},
		getSalesOrders(){
			SalesOrdersAPI.fetchSalesOrders({paging:'true',page: this.page, limit: this.salesOrderLimit, customerId:this.customerId, orderBy: 'date', direction: 'desc'})
				.then(salesOrders=>{
					this.totalPages = salesOrders.pages;
					this.salesOrders = salesOrders.list;
				})
		},
		setCustomerFields(){
			_.forEach(this.customer_fields, field=>{
				var fieldValue = _.find(this.customer.custom_fields, info=>{

					return field.id==info.id;
				})
				field.value = fieldValue!=null?fieldValue.value:null;
			})

		},
    handleCustomerStatisticVisibility(){
      if (this.customerStatisticVisible) {
        localStorage.setItem('showCustomerStatistic',0);
        this.customerStatisticVisible = false;
      }else {
        localStorage.setItem('showCustomerStatistic', 1);
        this.customerStatisticVisible = true;
      }

    },
		...mapActions('controlData',['fetchDeliveryTypes','fetchLocations']),
		...mapActions('customers', ['invalidateList'])
	},
	computed: {
      customerId() {
         if (_.get(this, 'customer.id') != null) {
            return parseInt(_.get(this, 'customer.id'));
         }
         return null;
      },
		portausCompany () {
			return _.get(this.customer, 'portausCompany.id');
		},
	lang() {
		return this.$i18n.locale;
	},
	titleLang(){
		return `title_${this.lang}`;
	},
	isNotEmpty () {
		return _.size(this.salesOrders) > 0;
	},
    isCustomerActive () {
      return _.get(this.customer, 'active');
    },
    customerNameValue(){
      if (this.customer != null) {
        return this.getCustomerName(this.customer);
      }
      return "";
    },
    tabHeight(){
      return "height :"+(this.pageHeight-250) + "px"
    },
		convertClientType(){
			if(this.customer==null) return "";
			return this.customer.type==1 ? this.$i18n.t('clients.types.individuel') : this.$i18n.t('clients.types.corporate');
		},
	companyName(){
	  if (localStorage.CIE_INFO == null) return null;
      return _.get(JSON.parse(localStorage.CIE_INFO), 'name');
    },
    fiscalEndDay(){
	  if (localStorage.CIE_INFO == null) return null;
	  return _.get(JSON.parse(localStorage.CIE_INFO), 'fiscalEndDay');
    },
    fiscalEndMonth(){
	  if (localStorage.CIE_INFO == null) return null;
      return _.get(JSON.parse(localStorage.CIE_INFO), 'fiscalEndMonth');
    },
    reportCode(){
      return this.$route.params.code;
    },
    lastFiscalYearDate(){
      let lastFiscalYearDate = {};
      let fiscalYearDate = this.fiscalYearDate;
      if(fiscalYearDate.startDate!=null && fiscalYearDate.endDate!=null){
        let startDate = moment(fiscalYearDate.startDate,'DD MMM YYYY').subtract(1,'year');
        let endDate = moment(fiscalYearDate.endDate,'DD MMM YYYY').subtract(1,'year');
        lastFiscalYearDate = {startDate, endDate}
      }

      return lastFiscalYearDate;
    },
    fiscalYearDate(){
      let fiscalYearDate = {};
      if(this.fiscalEndDay!=null && this.fiscalEndMonth!=null){
        let endDate = null;
        if(moment().format('M')>this.fiscalEndMonth){
          endDate = moment(this.fiscalEndMonth.toString()+'-'+this.fiscalEndDay.toString(),'MM-DD').add(1,'year');
        }else{
          endDate = moment(this.fiscalEndMonth.toString()+'-'+this.fiscalEndDay.toString(),'MM-DD');
        }
        let startDate = moment(endDate).subtract(1, 'year').add(1,'day');
        fiscalYearDate = {startDate, endDate};
      }
      return fiscalYearDate
    },
    month(){
      return {startDate : moment().startOf('month'), endDate : moment().endOf('month')}
    },
    lastMonth(){
      return {startDate : moment().subtract(1,'months').startOf('month'), endDate : moment().subtract(1,'months').endOf('month')}
    },
    last12Month(){
      return {startDate : moment().subtract(12,'months').startOf('month'), endDate : moment().subtract(1,'months').endOf('month')}
    },
		predefinedPeriod(){
      if(this.fiscalYearDate.startDate!=null && this.fiscalYearDate.endDate!=null){
        return [
					{code : 'MONTH', description:this.month.startDate.format('DD MMM YYYY') + '-' + this.month.endDate.format('DD MMM YYYY')},
          {code : 'LAST_MONTH', description:this.lastMonth.startDate.format('DD MMM YYYY') + '-'+this.lastMonth.endDate.format('DD MMM YYYY')},
					{code : 'LAST_12_MONTH', description:this.last12Month.startDate.format('DD MMM YYYY') + '-' + this.month.endDate.format('DD MMM YYYY')},
					{code : 'FISCAL_YEAR',description:this.fiscalYearDate.startDate.format('DD MMM YYYY') + '-'+this.fiscalYearDate.endDate.format('DD MMM YYYY')},
          {code : 'LAST_FISCAL_YEAR',description:this.lastFiscalYearDate.startDate.format('DD MMM YYYY') + '-'+this.lastFiscalYearDate.endDate.format('DD MMM YYYY')},
          {code : 'CUSTOM', range:true}
        ]
      }else{
        return [];
      }

    },
		deliveryDays(){
			if(this.deliveryScheduleType==="FIXEDDAYS"){
				let scheduleArray = _.filter(this.customer.customer_delivery_schedules, s=>{return s.active})
				let str = "";
				_.forEach(scheduleArray, (d,i)=>{
					str+=this.$i18n.t('sales_orders.deliveryDay_'+d.day);
					if(i+1<scheduleArray.length){str+=", ";}
				})
				return str;
			}else{
				return "";
			}
		},
		deliveryScheduleType(){
			if(this.customer.customer_delivery_schedules!=null && this.customer.customer_delivery_schedules.length>0){
				if(this.customer.customer_delivery_schedules[0].year==null){
					//fixedDays
					return "FIXEDDAYS";
				}
			}
			return null;
		},
		deliveryType(){
			if(this.customer.delivery_type!=null){
				return this.deliveryTypeByLanguage({lang:this.$i18n.locale,id:this.customer.delivery_type.id}).name;
			}
			return null;
		},
		getHeightStyle(){
			return "min-height :"+(this.pageHeight-100) + "px"
		},
    total_paid () {
      let totalPaid = 0;
      if (_.get(this.customer, 'balance_account.paid') != null) {
        totalPaid = _.get(this.customer, 'balance_account.paid');
      }
      return totalPaid;
    },
		total_revenue(){
			if(this.customer!==null && this.customer.balance_account!=null){
				return this.customer.balance_account.invoiced.toString()
			}
			return '0.00';
		},
		overdue(){
			if(this.customer!==null && this.customer.balance_account!=null){
				return this.customer.balance_account.overdue.toString()
			}
			return '0.00';
		},
		outstanding(){
			if(this.customer!==null && this.customer.balance_account!=null){
				return this.customer.balance_account.outstanding.toString()
			}
			return '0.00';
		},
		draft(){
			if(this.customer!==null && this.customer.balance_account!=null){
				return this.customer.balance_account.draft.toString()
			}
			return '0.00';
		},
		credit(){
			if(this.customer!==null && this.customer.balance_account!=null){
				return this.customer.balance_account.credit.toString()
			}
			return '0.00';
		},
		getContacts(){
			if(this.customer==null){
				return null
			}else{
				if(this.isIndividual){
					return [this.customer.contact]
				}else{
					return this.customer.company.contacts;
				}
			}
		},
		getAddresses(){
			if(this.customer==null){
				return null
			}else{
				if(this.isIndividual){
					return _.get(this.customer, 'contact.addresses');
				}else{
					return this.customer.company==null?null:this.customer.company.addresses;
				}
			}
		},
		customerId(){
			return this.$route.params.id;
		},
		isIndividual(){
			return this.customer.company==null;
		},
    getTypeOfCustomer(){
      if(this.isIndividual){
        return this.$i18n.t('clients.types.individuel');
      }
    	return this.$i18n.t('clients.types.corporatif');
    },
		...mapGetters('controlData', [ 'deliveryTypeByLanguage']),
		...mapGetters(['isInvoicingModuleactive', 'isExternalAccountAPIModuleactive']),
      ...mapGetters('inventory', ['isMultipleInventorySystem'])
	},
	mounted() {
    this.customerStatisticVisible = localStorage.getItem('showCustomerStatistic') === null || localStorage.getItem('showCustomerStatistic') == 1;
		this.setPageWidth();
		if(this.$route.query.activeTab!=null){
			this.activeTab = this.$route.query.activeTab;
		}

		this.fetchDeliveryTypes();
		this.fetchSales();
      this.getSalesOrders();

      return this.getCustomerInfo()
         .then(customerInfo=>{

				this.customer = customerInfo;

				const ps = new VuePerfectScrollbar(this.$refs.scrollContainer);
				this.fullScreenLoading=false;


				this.setCustomerFields();
				this.fetchWebAccess();


			}).catch(err=>{
				console.log(err);
			})


	}
}
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/_variables';



.contact-fiche-info{
	padding-left:10px!important;
}
  .title {
  	font-size : 1.6em;
  	font-weight:bold;
  	margin-right:10px;
  	margin-left:10px;
  	position:relative;
  	float:left;
  }
	.title.inactive{
			text-decoration: line-through;
		}
	.subtitle {
		font-size : 1em;
		top:10px;
		font-weight:normal;
		margin-right:20px;
		margin-left:0px;
		position:relative;
		float:left;
	}
 .customer-top-nav{
 	height:50px;
 }
.customer-settings, .customer-type{
	font-size : 1.0em;
	// position:relative;
	margin-right:5px;
  	// float:left;
  	// margin-top:-5px;
}
.customer-settings:hover{
	color:#4a596a;
	cursor:pointer;
}
.customer-controls{
	position:relative;
	float:right;
	button{
		margin-left:20px;
	}
}

.action-button {
  position: relative;
  float:right;
}

  .client-tabs{
  	margin-top:20px;
  }

div.sticky {
  position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 0;
}


</style>
